import { render, staticRenderFns } from "./Fanzones-urban-actions.vue?vue&type=template&id=334896fc&"
import script from "./Fanzones-urban-actions.vue?vue&type=script&lang=js&"
export * from "./Fanzones-urban-actions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports